const leaders = [
  {
    name: 'Pankaj Anand',
    title: 'Founder',
    bio: '15+ years in Financial Due Diligence, FP&A, Business Modeling & Pricing.',
    image: '/images/leadership/pankaj-anand.png',
  },
  {
    name: 'Bharat Sharma',
    title: 'Founder',
    bio: '15+ years in Accounting, FP&A, US Taxation & Business Operations.',
    image: '/images/leadership/bharat-sharma.png',
  },
  {
    name: 'Praful Lall',
    title: 'Founder',
    bio: '15+ years in Financial Due Diligence, Data Automation & Analytics.',
    image: '/images/leadership/prafull-lall.png',
  },
  {
    name: 'Keshav Sharma',
    title: 'Founder',
    bio: '5+ years in EdTech ecosystem & delivering technology-led initiatives.',
    image: '/images/leadership/keshav-sharma.png',
  },
];

function Leadership() {
  return (
    <section id="leadership" className="bg-brand-white py-6 lg:py-10">
      <div className="mx-auto max-w-[1440px] px-6 lg:px-10">
        <div className="mx-auto mb-10 max-w-2xl text-center lg:mb-14">
          <p className="mb-3 text-label font-semibold uppercase tracking-[0.2em] text-brand-primary">
            Our Team
          </p>
          <h2 className="text-section uppercase tracking-wide text-brand-navy sm:text-[36px]">
            Meet Our Leadership
          </h2>
          <div className="mx-auto mt-5 h-1 w-16 rounded-full bg-brand-primary" />
        </div>

        <div className="grid gap-4 sm:grid-cols-2 sm:gap-5 xl:gap-6">
          {leaders.map((leader) => (
            <article
              key={leader.name}
              className="flex items-center gap-4 rounded-2xl border border-brand-border bg-brand-white p-4 shadow-[0_12px_36px_-24px_rgba(17,22,44,0.35)] transition-shadow hover:shadow-[0_18px_40px_-20px_rgba(15,85,222,0.25)] sm:gap-5 sm:p-5"
            >
              <img
                src={leader.image}
                alt={leader.name}
                className="h-20 w-20 shrink-0 object-contain sm:h-24 sm:w-24 lg:h-28 lg:w-28"
              />

              <div className="min-w-0 flex-1">
                <h3 className="text-body font-bold text-brand-primary sm:text-card-title">
                  {leader.name}
                </h3>
                <p className="mt-0.5 text-body-sm text-brand-muted">{leader.title}</p>
                <p className="mt-1.5 text-label leading-relaxed text-brand-secondary sm:mt-2 sm:text-body-sm">
                  {leader.bio}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Leadership;
